import { render, staticRenderFns } from "./DropComponents.vue?vue&type=template&id=6e8be884&"
import script from "./DropComponents.vue?vue&type=script&lang=ts&"
export * from "./DropComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports